import { cn } from '@/shared/lib/cn';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { TooltipElement } from './tooltip';
import { Typography } from './typography';

type CheckboxProps = {
  label?: string;
  placement?: 'checkbox-label' | 'label-checkbox';
  fullWidth?: boolean;
  infoText?: string;
  checkboxClassName?: string;
} & ComponentPropsWithoutRef<'input'>;

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      fullWidth = false,
      disabled = false,
      placement = 'checkbox-label',
      label,
      infoText,
      className,
      checkboxClassName,
      ...props
    },
    ref
  ) => {
    return (
      <label
        className={cn(
          'flex cursor-pointer items-center gap-2',
          placement === 'label-checkbox' && 'flex-row-reverse',
          fullWidth && 'w-full justify-between',
          disabled && 'cursor-not-allowed',
          className
        )}
      >
        <input
          type="checkbox"
          ref={ref}
          disabled={disabled}
          className={cn(
            'bg-primary-6 border-neutral-5 disabled:bg-neutral-3 h-4 w-4 cursor-pointer rounded-xs focus:ring-blue-500 disabled:cursor-not-allowed',
            checkboxClassName
          )}
          {...props}
        />
        {label && (
          <>
            <Typography className={cn('select-none', disabled && 'opacity-50')}>
              {label}
            </Typography>
            {infoText && <TooltipElement content={infoText} />}
          </>
        )}
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';
